import { FC } from 'react';
import Select, { components, ActionMeta, GroupBase } from 'react-select';
import Icon from '../Icon';

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon name='chevron_down' size={12} color='#747474' />
    </components.DropdownIndicator>
  );
};

const ClearIndicator = (props: any) => {
  return <components.ClearIndicator {...props}>bio</components.ClearIndicator>;
};

export interface SelectFieldProps {
  label: string;
  options: { label: string; value: string | number }[];
  name: string;
  id?: string;
  value?: string;
  onChange: (v: any) => void;
}

const SelectField: FC<SelectFieldProps> = ({ label, options, ...props }) => {
  // const [field, meta, { setValue, setTouched }] = useField(props);

  // @ts-ignore
  // const onChange = (e) => {
  //   //setValue(value);
  //   console.log(e);
  // };

  return (
    <div>
      {/* <label htmlFor={props.id || props.name} className='form-label'>
        {label}
      </label> */}
      <Select
        classNamePrefix='colorRamp__select'
        closeMenuOnSelect={false}
        placeholder={label}
        components={{ DropdownIndicator, ClearIndicator }}
        defaultValue={options.find((option) => option.value === 'light_theme')}
        options={options}
        // @ts-ignore
        onChange={props.onChange}
        // @ts-ignore
        //  onBlur={setTouched}
        // isMulti
      />
      {/* {meta.touched && meta.error ? <div className='form-text text-danger'>{meta.error}</div> : null} */}
    </div>
  );
};
export default SelectField;
